<template>
    <div class="card results-container rounded border-0">
        <slot name="card-header">
            <div class="title font-weight-xbold font-size-xl px-3 py-2 pb-0">{{ $t('Estetiste') }}</div>
            <!--<div class="card-header card-header-sm d-flex justify-content-between">-->
                <!--<div class="title d-flex align-items-center">-->
                    <!--&lt;!&ndash;<div class="circle-container background-primary d-flex justify-content-center align-items-center mr-2">&ndash;&gt;-->
                        <!--&lt;!&ndash;<i class="cf-friends"></i>&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--<span> {{ $t('Estetiste') }}</span>-->
                <!--</div>-->
                <!--&lt;!&ndash;<div class=" d-flex view-options align-items-center" v-if="users.totalCount && !limit && !mobileMode">&ndash;&gt;-->
                    <!--&lt;!&ndash;<a href="#" :class="{'selected': view === 'grid'}" @click.prevent="gridView"><i class="fa fa-lg cf-grid"></i></a>&ndash;&gt;-->
                    <!--&lt;!&ndash;<span class="divider"></span>&ndash;&gt;-->
                    <!--&lt;!&ndash;<a href="#" :class="{'selected': view === 'list'}" @click.prevent="listView"><i class="fa fa-lg cf-list"></i></a>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--</div>-->
        </slot>
      <div class="d-none d-lg-flex w-100 pl-3">
        <div>
          <i class="font-size-sm">{{ (users.usersCount > 0 ?  users.usersCount + 9000 : '').toLocaleString() }} Estetiste</i>
        </div>
      </div>
        <div class="results-body pr-3 pl-3">
            <div class="row">
                <div :class="view == 'list' ? 'col-lg-12' : 'col-lg-3'" v-for="user in filteredUsers" :key="user.id">
                    <user-result class="result-row" :user="user" :view="view">
                        <template slot="dropdown-menu">
                            <slot name="dropdown-menu"></slot>
                        </template>
                    </user-result>
                    <hr v-if="(view == 'list' || mobileMode) && user.id != lastUser.id">
                </div>
            </div>
            <p class="m-3" v-if="users.pagination.last_page == page">* La lista delle estetiste iscritte a Confestetica comprende esclusivamente professioniste certificate dall’associazione, in conformità ai requisiti stabiliti con delibera del Direttivo del 20 novembre 2007. La certificazione prevede l’accertamento del possesso del titolo di estetista, conseguito presso enti riconosciuti secondo la normativa vigente, e l’adesione allo statuto e al codice deontologico dell’associazione.
            <br><br>
              Con la registrazione, le estetiste e i centri acquisiscono il diritto alla rappresentanza e tutela da parte di Confestetica, in base allo statuto notarile del 19 novembre 2007 (Rep. 41.548, Racc. 6.443). La registrazione può essere effettuata tramite il portale ufficiale, canali web riconosciuti o procedimenti offline verificati.</p>
            <div class="justify-content-center background-white align-items-center pt-3 d-none d-lg-flex" v-if="!limit && users.pagination.last_page > 1">
                <b-pagination-nav :link-gen="paginatedPath" :number-of-pages="users.pagination.last_page" :value="$route.query.page || 1" use-router @change="goToPage"></b-pagination-nav>
            </div>
            <client-only>
                <infinite-loading @infinite="loadMore" force-use-infinite-wrapper=".page" ref="infiniteLoading" class="d-block d-lg-none">
                    <span class="d-flex justify-content-center" slot="spinner">
                        <img alt="loading" src="~/assets/images/icons/loading.svg" class="fa fa-spin m-3" width="36px">
                    </span>
                    <span class="d-flex flex-column justify-content-center align-items-center" slot="no-more">
                        <i class="fa fa-search fa-4x text-grey mt-5" v-if="!limit && !filteredUsers.length"></i>
                        <span class="p-2 text-grey" v-if="!filteredUsers.length">{{ $t('Nessun risultato') }}</span>
                        <span class="p-2 text-grey" v-if="!limit && filteredUsers.length"><i>{{ $t('Fine dei risultati') }}</i></span>
                    </span>
                    <template slot="no-results">
                        <div class="d-flex justify-content-center align-items-center background-white">
                            <div class="p-3"><i>{{ $t('Non sono stati trovati risultati corrispondenti alla tua ricerca.') }}</i></div>
                        </div>
                    </template>
                </infinite-loading>
            </client-only>
        </div>
        <div class="p-2 pr-3 pl-3 results-footer" v-if="filteredUsers.length && limit">
            <button class="btn btn-sm background-gray font-weight-medium w-100" @click.prevent="setActive" v-if="filteredUsers.length < $store.state.users.totalCount">{{ $t('Mostra tutte') }}</button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
    import UserResult from '~/components/SearchUsers/Result'
    import { BPaginationNav } from 'bootstrap-vue';
    import _ from 'lodash'

    export default {

        // props: ['limit', 'filters'],
        props: {
            limit: {
                type: Number,
                default: function () {
                    return 0
                }
            },
            filters: {
                type: Object,
                default: function () {
                    return {
                        profile_rank: [],
                        status: 'published',
                    }
                },
            }
        },

        data: function () {
            return {
                view: 'list',
                loading: false,
                page: 1
            }
        },

        components: {
            UserResult,
            BPaginationNav
        },

        watch: {

            $route (to, from) {
                if (to.path === from.path) {
                    this.page = to.query.page
                    this.$store.commit('users/SET_USERS', [])
                    this.$nuxt.$loading.start()
                    this.fetchMore({page: this.page, filters: {...this.filters, text: this.users.filters.text}})
                        .then(() => {
                            this.$nuxt.$loading.finish()
                        })
                }
            }
        },

        computed: {
            ...mapGetters({
                'getUsersByFilters': 'users/getUsersByFilters'
            }),
            ...mapState([
                'user',
                'users',
                'mobileMode'
            ]),
            filteredUsers() {

                let users = this.getUsersByFilters({...this.filters, text: this.users.filters.text});

                if (this.limit) {
                    return users.slice(0, this.limit);
                } else {
                    return users;
                }
            },
            lastUser() {
                return _.last(this.filteredUsers);
            }
        },

        methods: {
            ...mapActions({
               'fetchMore': 'users/fetchMore'
            }),
            paginatedPath (page) {
                return {
                    path: this.$route.path,
                    query: { page }
                }
            },
            goToPage (page) {
              this.$router.push({ path: this.$route.path, query: { page: page } })
            },
            gridView () {
                this.view = 'grid'
            },
            listView () {
                this.view = 'list'
            },
            updateLoaderState () {
                this.$refs.infiniteLoading.stateChanger.loaded();

                if (!this.users.infiniteScrollEnabled || this.limit) {
                    this.$refs.infiniteLoading.stateChanger.complete();
                }
            },
            async loadMore () {
                this.fetchMore({ page: this.page, filters: {...this.filters, text: this.users.filters.text} }).then(() => {

                    this.updateLoaderState()
                    this.page++;
                })
            },
            setActive () {
                this.$router.push('/estetiste')
            }
        },

        asyncData({ route }) {
            return {
                view: 'list',
                loading: false,
                page: route.query.page
            }
        },

        mounted () {
            this.$nuxt.$on('search-users', () => {
                this.page = 1;
                this.$refs.infiniteLoading.stateChanger.reset();
            })
            this.page = this.$route.query.page || 1
          this.$store.dispatch('users/fetchCount')
        }
    }
</script>

<style lang="scss" scoped>

    .card-header {
        .title {
            margin-left: -15px;
        }
    }

    .card-body {
        padding-top: 0!important;
    }

    .result-row {
        padding-top: 18px;

    }

    .circle-container {
        width: 30px;
        height: 30px;
        color: white;
    }

    .divider {
        margin: 0 14px;
        width: 2px;
        height: 33px;
        border: 1px solid #F4F2F3;
    }
</style>
